import { keycloak } from 'lib/keycloak'

// Memoized so keycloak.init() runs at most once per page: init() can only be called
// once, and React 18 StrictMode double-invokes effects in dev — the second call
// reuses this cached promise instead of throwing.
//
// Kept LAZY (not executed at module import) on purpose: init fires only when
// KeycloakProvider actually mounts, not when this module is imported. This keeps the
// module importable in tests without firing a real init() call.
let initPromise: Promise<boolean> | null = null

export const ensureKeycloakInitialized = (): Promise<boolean> => {
  if (!initPromise) {
    initPromise = keycloak.init({ onLoad: 'check-sso' })
  }

  return initPromise
}
